/* eslint-disable no-unused-expressions */
import React, { Component } from 'react';
import moment from 'moment';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import IconsPath from "../../../assets/icons/index";
import LanguageTranslator from '../../../locals/LanguageTranslator';
import { CONFIG } from '../../../config';
import { displayNamesForNewSubmitApi } from './DisplayNameForNewServer';
import UseDatePickerLocale from '../../input/LocaleInputDatePicker';
import GenericCustomButton from '../../GenericCustomButton';
import { getMenuMode } from '../../../helper/helperTableFunctions';
const { RangePicker } = DatePicker;

const totalItemsLimitList = {
    // "PO_TO_GRN_SUMMARY_HEADERS":200000,
    // "PO_TO_GRN_HEADERS":200000,
    "PO_TABLE_HEADER_MAIN": 1000,
    PI_TABLE_HEADER_MAIN: 1000,
    PO_TABLE_HEADER_PENDING: 1000,
    PO_TABLE_HEADER_APPROVED: 1000,
    PI_TABLE_HEADER_PENDING: 1000,
    PI_TABLE_HEADER_APPROVED: 1000
}

export class DownloadReport extends Component {
    constructor(props){
        super(props);
        this.state={
            search: "",
            headersLevel: "main",
            headersType: this.props.mainHeadersType,
            isCustomHeadersAvailable: this.props.mainHeadersType === "Custom Headers",
            headersMap: this.props.mainHeadersData[this.props.mainHeadersType],
            selectedItems: this.props.mainHeadersData[this.props.mainHeadersType],
            exportFilters: this.props.mainHeadersData.exportFilters ? this.props.mainHeadersData.exportFilters.map(item => ({...item, input: {from: "", to: ""}, error: false})) : [],
            dateDropdown: "",
            checkBoxes : {
                enableExportFilters : false,
            },
            //Making a state to see if custom filters will be available or not in the given file.
            isCustomFiltersAvailable: totalItemsLimitList.hasOwnProperty(this.props.mainHeadersKey) ? this.props.dataLength >= totalItemsLimitList[this.props.mainHeadersKey] ? true : false : true,
            detailHeadersType: ""
        };
        this.updatedLocale =  UseDatePickerLocale();
    }

    componentDidUpdate(){
        if(this.props.generalStore.downloadReportData.isSuccess){
            this.props.close();
        }
    }

    componentDidMount() {
        document.addEventListener("keydown", this.closeOnEsc);
        if(this.props.detailHeadersData) {
            const isCustomHeadersAvailable = this.props.mainHeadersType === "Custom Headers" && this.props.detailHeadersType.every(item => item === "Custom Headers");
            this.setState({
                detailHeadersType: isCustomHeadersAvailable ? "Custom Headers" : "Default Headers",
                isCustomHeadersAvailable
            });
        }
        if(typeof this.props.payload.filter === "object" && Object.keys(this.props.payload.filter).length > 0) {
            const filter = this.props.payload.filter, exportFilters = this.state.exportFilters;
            exportFilters.forEach(item => {
                if(filter[item.key]) {
                    item.input = {...filter[item.key]};
                    switch(item.type) {
                        case "NUMBER": {
                            if(Number(filter[item.key].from) - Number(filter[item.key].to) > item.range) {
                                item.error = true;
                            }
                            break;
                        }
                        case "DATE": {
                            if(moment(filter[item.key].to).diff(moment(filter[item.key].from), "days") > item.range) {
                                item.error = true;
                            }
                            break;
                        }
                    }
                }
            });
            this.setState({
                exportFilters
            });
        }
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.closeOnEsc);
    }

    closeOnEsc = e => {
        if(e.key === "Escape") {
            this.props.close();
        }
    }

    handleInput = e => {
        const field = e.target.name, value = e.target.value;
        this.setState({
            [field]: value
        }, () => {
            if(field === "headersLevel" || field === "headersType") {
                this.setHeaders();
            }
        });
    }

    setHeaders = () => {
        let headersMap = {};
        headersMap = {...this.props.mainHeadersData[this.state.headersType]};
        if(this.state.headersLevel === "detail") {
            this.props.detailHeadersData.forEach(item => {
                headersMap = {
                    ...headersMap,
                    ...item[this.state.detailHeadersType]
                };
            });
        }
        this.setState({
            headersMap,
            selectedItems: headersMap
        });
    }

    selectItem = e => {
        const key = e.target.name;
        this.setState(prevState => {
            let selectedItems = {...prevState.selectedItems};
            if(selectedItems[key]) {
                delete selectedItems[key];
            }
            else {
                selectedItems[key] = prevState.headersMap[key];
            }
            return {
                selectedItems
            };
        });
    }

    handleSelectAll = () => {
        this.setState(prevState => {
            if(Object.keys(prevState.selectedItems).length === Object.keys(prevState.headersMap).length) {
                return {
                    selectedItems: {}
                };
            }
            return {
                selectedItems: {...prevState.headersMap}
            };
        });
    }

    handleFiltersInput = (e, item) => {
        try {
            e.persist();
        }
        catch(err) {}
        
        this.setState(prevState => {
            const exportFilters = [...prevState.exportFilters],
            index = exportFilters.findIndex(innerItem => innerItem.key === item.key);
            switch(item.type) {
                case "NUMBER": {
                    exportFilters[index].input[e.target.dataset.type] = Number(e.target.value) || "";
                    if(exportFilters[index].input.to - exportFilters[index].input.from > exportFilters[index].range) {
                        exportFilters[index].error = true;
                    }
                    else {
                        exportFilters[index].error = false;
                    }
                    break;
                }
                case "DATE": {
                    if(e === null) {
                        exportFilters[index]["input"] = {
                            from: "",
                            to: ""
                        };
                    }
                    else if(["SM_DATE_TODAY_VALUE", "SM_DATE_YESTERDAY_VALUE", "SM_DATE_LAST7DAYS_VALUE", "SM_DATE_LASTWEEK_VALUE", "SM_DATE_THISMONTH_VALUE", "SM_DATE_LASTMONTH_VALUE"].includes(e)) {
                        exportFilters[index]["input"] = {
                            ...this.getDateFromTo(e),
                            key: e
                        };
                    }
                    else {
                        exportFilters[index]["input"] = {
                            from: moment(e[0].$d).format('YYYY-MM-DD'),
                            to: moment(e[1].$d).format('YYYY-MM-DD')
                        };
                    }
                    if(moment(exportFilters[index]["input"].to).diff(moment(exportFilters[index]["input"].from), "days") > exportFilters[index].range) {
                        exportFilters[index].error = true;
                    }
                    else {
                        exportFilters[index].error = false;
                    }
                    break;
                }
            }
            return {exportFilters};
        });
    }

    getDateFromTo = key => {
        switch(key) {
            case "SM_DATE_TODAY_VALUE": {
                return {
                    from: moment().format('YYYY-MM-DD'),
                    to: moment().format('YYYY-MM-DD')
                };
            }
            case "SM_DATE_YESTERDAY_VALUE": {
                return {
                    from: moment().subtract(1, "day").format('YYYY-MM-DD'),
                    to: moment().subtract(1, "day").format('YYYY-MM-DD')
                };
            }
            case "SM_DATE_LAST7DAYS_VALUE": {
                return {
                    from: moment().subtract(7, "days").format('YYYY-MM-DD'),
                    to: moment().subtract(1, "day").format('YYYY-MM-DD')
                };
            }
            case "SM_DATE_LASTWEEK_VALUE": {
                return {
                    from: moment().subtract(1, 'week').startOf('isoWeek').format('YYYY-MM-DD'),
                    to: moment().subtract(1, 'week').endOf('isoWeek').format('YYYY-MM-DD')
                };
            }
            case "SM_DATE_THISMONTH_VALUE": {
                return {
                    from: moment().startOf('month').format('YYYY-MM-DD'),
                    to: moment().format('YYYY-MM-DD')
                };
            }
            case "SM_DATE_LASTMONTH_VALUE": {
                return {
                    from: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
                    to: moment().subtract(1,'month').endOf('month').format('YYYY-MM-DD'),
                };
            }
            default: {
                return {
                    from: "",
                    to: ""
                };
            }
        }
    }

    renderExtraFooter = item => () => {
        return(
            <span className="date-picker-extra-footer">
                <label className="radio-label">
                    <input type="radio" name="daterange" checked={typeof item.input === "object" && item.input.key === "SM_DATE_TODAY_VALUE"} onChange={e => this.handleFiltersInput("SM_DATE_TODAY_VALUE", item)} />
                    <span className="radio-check"></span>
                    <span className="radio-text"><LanguageTranslator>Today</LanguageTranslator></span>
                </label>
                <label className="radio-label">
                    <input type="radio" name="daterange" checked={typeof item.input === "object" && item.input.key === "SM_DATE_YESTERDAY_VALUE"} onChange={e => this.handleFiltersInput("SM_DATE_YESTERDAY_VALUE", item)} />
                    <span className="radio-check"></span>
                    <span className="radio-text"><LanguageTranslator>Yesterday</LanguageTranslator></span>
                </label>
                <label className="radio-label">
                    <input type="radio" name="daterange" checked={typeof item.input === "object" && item.input.key === "SM_DATE_LAST7DAYS_VALUE"} onChange={e => this.handleFiltersInput("SM_DATE_LAST7DAYS_VALUE", item)} />
                    <span className="radio-check"></span>
                    <span className="radio-text"><LanguageTranslator>Last 7 Days</LanguageTranslator></span>
                </label>
                <label className="radio-label">
                    <input type="radio" name="daterange" checked={typeof item.input === "object" && item.input.key === "SM_DATE_LASTWEEK_VALUE"} onChange={e => this.handleFiltersInput("SM_DATE_LASTWEEK_VALUE", item)} />
                    <span className="radio-check"></span>
                    <span className="radio-text"><LanguageTranslator>Last Week</LanguageTranslator></span>
                </label>
                <label className="radio-label">
                    <input type="radio" name="daterange" checked={typeof item.input === "object" && item.input.key === "SM_DATE_THISMONTH_VALUE"} onChange={e => this.handleFiltersInput("SM_DATE_THISMONTH_VALUE", item)} />
                    <span className="radio-check"></span>
                    <span className="radio-text"><LanguageTranslator>This Month</LanguageTranslator></span>
                </label>
                <label className="radio-label">
                    <input type="radio" name="daterange" checked={typeof item.input === "object" && item.input.key === "SM_DATE_LASTMONTH_VALUE"} onChange={e => this.handleFiltersInput("SM_DATE_LASTMONTH_VALUE", item)} />
                    <span className="radio-check"></span>
                    <span className="radio-text"><LanguageTranslator>Last Month</LanguageTranslator></span>
                </label>
            </span>
        );
    }

    isSubmitDisabled = () => {
        if(this.props.dataLength <= 100) {
            return this.state.isCustomFiltersAvailable ? Object.keys(this.state.selectedItems).length === 0 : Object.keys(this.state.selectedItems).length === 0;
        }
        else return this.state.isCustomFiltersAvailable ? Object.keys(this.state.selectedItems).length === 0 || this.state.exportFilters.some(item => !item.input.from || !item.input.to || item.error) : Object.keys(this.state.selectedItems).length === 0;
    }

    translateObjectValues = (obj) => {
        const translated = {};
        for (const key in obj) {
            translated[key] = LanguageTranslator({ children: obj[key] });
        }
        return translated;
    };

    onSubmit = () => {
        let  payload = JSON.parse(JSON.stringify(this.props.payload));
        if(this.state.exportFilters.length) {
            payload.type == 1 ? payload.type = 2 : null;
            this.state.exportFilters.forEach(item => {
                    if(this.state.checkBoxes.enableExportFilters && this.props.mainHeadersData.exportFilters && this.props.mainHeadersData.exportFilters.length > 0 && this.props.mainHeadersData.exportFilters.key == item.key){
                        switch(item.type){
                            case 'DATE' : {
                                if(item.input.from != '' && item.input.to != ''){
                                    payload.filter[item.key] = item.input;
                                }
                                break
                            }
                            default : payload.filter[item.key] = item.input;
                        }
                    }
                    else{
                        switch(item.type){
                            case 'DATE' : {
                                if(item.input.from != '' && item.input.to != ''){
                                    payload.filter[item.key] = item.input;
                                }
                                break
                            }
                            default : payload.filter[item.key] = item.input;
                        }
                    }
            });
        }

        let moduleName =  this.state.headersLevel === "main" ? this.props.headerLevelModule : this.props.detailLevelModule;

        if(this.props.detailLevelModule === "PO_TABLE_HEADER_DET" || this.props.detailLevelModule === "PI_TABLE_HEADER_DET") {
            
            let val = {
                module: this.state.headersLevel === "main" ? this.props.headerLevelModule : this.props.detailLevelModule,
                isAllData: this.state.headersLevel === "detail",
                isOnlyCurrentPage: false,
                data: {
                    ...payload,
                    filter: payload.filter,
                    reportFilter:payload.reportFilter,
                    headers: this.translateObjectValues(this.state.selectedItems),
                    isMainHeader: this.state.headersLevel === "main" ? true : false
                },
            }

            if(moduleName?.split(',')?.some(item => displayNamesForNewSubmitApi?.[item])){
                val["apiUrl"] = '/admin/download/module/data/export';
                val["baseUrl"] = CONFIG.SM_BACKEND_BASE_URL;
            }

            // const changeAPIForDisplayName = {
            //     PO_TABLE_HEADER_MAIN: true,
            //     PO_TABLE_HEADER_PENDING: true,
            //     PO_TABLE_HEADER_APPROVED: true,
            //     PO_TABLE_HEADER_DET: true,
            // }

            // if(getMenuMode?.() == "new" && moduleName?.split(',')?.some(item => changeAPIForDisplayName?.[item])) {
            //     val["apiUrl"] = '/admin/download/module/data/export';
            //     val["baseUrl"] = CONFIG.SM_BACKEND_BASE_URL;
            // }

            this.props.submit(val);
        }
        else {

            let val = {
                module: this.state.headersLevel === "main" ? this.props.headerLevelModule : this.props.detailLevelModule,
                isAllData: this.state.headersLevel === "detail",
                isOnlyCurrentPage: false,
                data: {
                    ...payload,
                    filter: payload.filter,
                    reportFilter:payload.reportFilter,
                    headers: this.translateObjectValues(this.state.selectedItems)
                }
            }
            if(moduleName?.split(',')?.some(item => displayNamesForNewSubmitApi?.[item])){
                val["apiUrl"] = '/admin/download/module/data/export';
                val["baseUrl"] = CONFIG.SM_BACKEND_BASE_URL;
            }

            this.props.submit(val);
        }
    }
    handleChange= (e) =>{
        let checkBoxes = {...this.state.checkBoxes}
        checkBoxes[e.target.name] = !this.state.checkBoxes
        this.setState({
            checkBoxes
        })
    }

    closeReportModal = () => {
		document.getElementById("reportModal")?.classList?.remove("from-right-in")
		document.getElementById("reportModal")?.classList?.add("from-right-out")
		setTimeout(()=>{
			this.props.close();
		}, 100)
	}

    render() {
        return (
            <div className="modal">
                <div className="backdrop modal-backdrop-new" onClick={this.closeReportModal}></div>
                <div id='reportModal' className="modal-content email-report-modal !w-auto !flex !flex-row !absolute top-[0] right-[0] h-full !bg-white z-[99] !border-none !shadow-none !rounded-none from-right-in">

                    <div 
                        className={ `h-full w-[420px] ${this.state.exportFilters.length !== 0 ? 'border-r border-borderSlateGrey' : ''}`}
                        style={{
                            boxShadow: this.state.exportFilters.length !== 0 ? '2px 0px 10px 0px #73727226' : ''
                        }}
                    >
                        <div className="erm-head block py-[15px] px-[25px]">
                            <LanguageTranslator tag="h3" className='text-base font-bold text-[#12203c] inline-block m-[0] leading-[25px]'>Download Report</LanguageTranslator>
                            {
                            this.state.exportFilters.length === 0 &&
                                <span className="ermh-close flex items-center relative float-right cursor-pointer" onClick={this.closeReportModal}>
                                    <span className="ermh-esc text-xs font-medium relative text-[#969fad] mr-[15px]">Esc</span>
                                    <IconsPath.ClearSearch />
                                </span>
                            }
                        </div>
                        <div className="erm-search-fields flex items-center justify-between gap-3 py-[12px] px-[25px] border-t border-borderSlateGrey">
                            <div className="gen-pi-formate !p-[0]">
                                <ul className="gpf-radio-list">
                                    <li>
                                        <label className="gen-radio-btn">
                                            <input type="radio" name="headersLevel" value="main" checked={this.state.headersLevel === "main"} onClick={this.handleInput} />
                                            <span className="checkmark"></span>
                                            <LanguageTranslator>Header Level Data</LanguageTranslator>
                                        </label>
                                    </li>
                                    {this.props.detailHeadersData && <li>
                                        <label className="gen-radio-btn">
                                            <input type="radio" name="headersLevel" value="detail" checked={this.state.headersLevel === "detail"} onClick={this.handleInput} disabled={!this.props.detailHeadersData} />
                                            <span className="checkmark"></span>
                                            <LanguageTranslator>Detail Level Data</LanguageTranslator>
                                        </label>
                                    </li>}
                                </ul>
                            </div>
                        </div>
                        <div className="erm-search-fields flex items-center justify-between gap-3 py-[12px] px-[25px] border-t border-borderSlateGrey">
                            <select className='shrink-0' name="headersType" value={this.state.headersType} onChange={this.handleInput} disabled={!this.state.isCustomHeadersAvailable}>
                                <LanguageTranslator tag="option" value="" disabled>Select Option</LanguageTranslator>
                                <LanguageTranslator tag="option" value="Default Headers">Default</LanguageTranslator>
                                <LanguageTranslator tag="option" value="Custom Headers">Custom</LanguageTranslator>
                            </select>
                            <div className="ermsf-search w-full">
                                <button type="button">
                                    <svg className='m-lft-5' width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.25 1.5A6.752 6.752 0 0 1 15 8.25 6.752 6.752 0 0 1 8.25 15 6.752 6.752 0 0 1 1.5 8.25 6.752 6.752 0 0 1 8.25 1.5zm0 12c2.9 0 5.25-2.35 5.25-5.25C13.5 5.349 11.15 3 8.25 3A5.248 5.248 0 0 0 3 8.25c0 2.9 2.349 5.25 5.25 5.25zm6.364.053 2.121 2.121-1.06 1.061-2.122-2.121 1.06-1.06z" fill="#21314b"></path>
                                    </svg>
                                    <input type="text" autoComplete="off" name="search" value={this.state.search} onChange={this.handleInput} placeholder="Search headers..." />
                                </button>
                            </div>
                        </div>
                        <div className={`drm-body p-[0] border-t border-borderSlateGrey flex flex-col overflow-auto ${this.state.exportFilters.length !== 0 ? 'h-[calc(100%-254px)]' : 'h-[calc(100%-224px)]'}`}>
                            <div className={`drm-checkbox py-[15px] px-[25px] border-b border-borderSlateGrey overflow-auto drmb-for-potogrn ${Object.keys(this.state?.headersMap)?.length > 0 ? 'h-full' : 'h-[calc(100%-121px)]'}`}>
                                <label className="checkBoxLabel0 drm-select-all">
                                    <input type="checkBox" checked={Object.keys(this.state.selectedItems || {})?.length === Object.keys(this.state.headersMap || {})?.length} onChange={this.handleSelectAll} />
                                    <LanguageTranslator>Select All</LanguageTranslator>
                                    <span className="checkmark1"></span>
                                </label>
                                {Object.keys(this.state.headersMap).map(key =>
                                    this.state.headersMap[key].toLowerCase().includes(this.state.search.toLowerCase()) ?
                                    <label className="checkBoxLabel0" key={key}>
                                        <input type="checkBox" checked={this.state.selectedItems[key] !== undefined} onChange={this.selectItem} name={key} />
                                        <LanguageTranslator>{this.state.headersMap[key]}</LanguageTranslator>
                                        <span className="checkmark1"></span>
                                    </label> :
                                    null
                                )}
                            </div>
                        </div>
                        <div className="erm-footerv2 block py-3.5 px-[25px] bg-white">
                            {/* {this.props.loading ?
                            <button type="button" className="generic-approve-btn btn-loader" disabled><div className="spinner-border"></div></button> :
                            !this.props.downloadReportName && this.isSubmitDisabled() ?
                            <button type='button' className='generic-approve-btn opacity04;' disabled>Download Report</button> :
                            <button type='button' className='generic-approve-btn' onClick={this.onSubmit}><LanguageTranslator>Download Report</LanguageTranslator></button>} */}

                            {this.state.exportFilters.length !== 0 && <label className="checkBoxLabel0 mb-3 text-[13px] font-normal text-[#21314B]">
                                <input type="checkbox"  name="enableExportFilters" onChange={this.handleChange}/><LanguageTranslator>Download report with other applied filters</LanguageTranslator><span className="checkmark1"></span>
                            </label>}

                            <GenericCustomButton
                                type='primary'
                                loading={this.props.loading}
                                disabled={this.props.loading || (!this.props.downloadReportName && this.isSubmitDisabled())}
                                onClick={this.onSubmit}
                                label={'Download Report'}
                                size='large'
                            />
                        </div>
                    </div>

                    {this.state.exportFilters.length !== 0 && <div className='h-full w-[300px] bg-[#FAFAFA] flex flex-col'>
                        <div className="erm-head block py-[15px] px-[25px]">
                            <LanguageTranslator tag="h3" className='text-base font-bold text-[#12203c] inline-block m-[0] leading-[25px]'>Filters</LanguageTranslator>
                            <span className="ermh-close flex items-center relative float-right cursor-pointer" onClick={this.closeReportModal}>
                                <span className="ermh-esc text-xs font-medium relative text-[#969fad] mr-[15px]">Esc</span>
                                <IconsPath.ClearSearch />
                            </span>
                        </div>

                        <div className={`drm-body pt-[10px] pb-[15px] px-[25px] border-y border-borderSlateGrey flex flex-col overflow-auto h-full`}>
                            <div className="drm-filters">
                                {this.state.exportFilters.map(item =>
                                    item.type === "NUMBER" ?
                                    <div key={item.key} className="drmf-number w-[70%] mb-[16px] text-xs">
                                        <label className='gib-label-heading'>{item.value}</label>
                                        <div className='flex justify-between h-[34px]'>
                                            <input
                                                className={`w-[48%] rounded-[4px] border border-borderSlateGrey py-0 px-2.5 ${item.error ? "errorBorder" : ""}`}
                                                type="number"
                                                data-type="from"
                                                id={item.key + "From"}
                                                value={item.input.from}
                                                placeholder="From"
                                                onChange={(e) => this.handleFiltersInput(e, item)}
                                            />
                                            <input
                                                className={`w-[48%] rounded-[4px] border border-borderSlateGrey py-0 px-2.5 ${item.error ? "errorBorder" : ""}`}
                                                type="number"
                                                data-type="to"
                                                id={item.key + "To"}
                                                value={item.input.to}
                                                placeholder="To"
                                                onChange={(e) => this.handleFiltersInput(e, item)}
                                            />
                                        </div>
                                        {item.error && <span className='error'><LanguageTranslator>Allowed range is</LanguageTranslator> {item.range}</span>}
                                    </div> :

                                    // item.type === "DATE"
                                    <div key={item.key} className="drmf-date mb-[22px]">
                                        <label className='gib-label-heading'>{item.value}</label>
                                        <RangePicker
                                            locale = {this.updatedLocale}
                                            className={item.error ? "errorBorder" : ""}
                                            format="YYYY-MM-DD"
                                            id={item.key}
                                            value={[item.input.from ? dayjs(item.input.from) : null, item.input.to ? dayjs(item.input.to) : null]}
                                            onChange={(e) => this.handleFiltersInput(e, item)}
                                            renderExtraFooter={this.renderExtraFooter(item)}
                                            onOpenChange={open => open ? this.setState({dateDropdown: item.key}) : this.setState({dateDropdown: ""})}
                                            open={this.state.dateDropdown === item.key}
                                        />
                                        {item.error && <span className='error-msg'>Allowed range is {item.range} days</span>}
                                    </div>
                                )}

                                {Object.keys(this.props.payload.filter).length != 0 && <div className='space-y-4'>
                                    {Object.keys(this.props.payload.filter).map(key => {
                                        if(key === "item") {
                                            return <div>
                                                <h5 className='mb-2 text-xs font-medium text-[#67768E]'>{this.props.mainHeadersData && this.props.mainHeadersData.item && this.props.mainHeadersData.item[this.props.mainHeadersType && this.props.mainHeadersType.item && this.props.mainHeadersType.item][key]}</h5>
                                                <div className='flex flex-wrap items-center gap-3'>
                                                    {
                                                        Object.keys(this.props.payload.filter.item).map(key=> (
                                                            <div className="px-2.5 py-1 bg-white w-fit text-xs font-medium text-[#21314B] border border-[#CED5E1] rounded-full break-words [word-break:break-word]">
                                                                {this.props.getItemFilterValue(key)}
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        } else if(this.props.mainHeadersData[this.props.mainHeadersType][key]?.toLowerCase()?.includes('status')) {
                                            let statusList = this.props.getFilterValue(key)?.split(',');
                                            return <div>
                                                <h5 className='mb-2 text-xs font-medium text-[#67768E]'>{this.props.mainHeadersData[this.props.mainHeadersType][key]}</h5>
                                                <div className='flex flex-wrap items-center gap-2.5'>
                                                    {
                                                        statusList?.map((item)=> (
                                                            <div className="px-2.5 py-1 bg-white w-fit text-xs font-medium text-[#21314B] border border-[#CED5E1] rounded-full break-words [word-break:break-word]">
                                                                {item}
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        }
                                        return <div> 
                                            <h5 className='mb-2 text-xs font-medium text-[#67768E]'>{this.props.mainHeadersData[this.props.mainHeadersType][key]}</h5>
                                            <div className="px-2.5 py-1 bg-white w-fit text-xs font-medium text-[#21314B] border border-[#CED5E1] rounded-full break-words [word-break:break-word]">
                                                    {this.props.getFilterValue(key)}
                                            </div>
                                        </div>
                                        }
                                    )}
                                </div>}
                            </div>
                        </div>
                    </div>}

                </div>
            </div>
        );
    }
}

export default DownloadReport;